import { render } from "./Tinymce.vue?vue&type=template&id=53bbc5e3"
import script from "./Tinymce.vue?vue&type=script&lang=js"
export * from "./Tinymce.vue?vue&type=script&lang=js"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__